import { takeEvery, put, call } from "redux-saga/effects";
import apiCall from "../services";

const apiUrl = process.env.REACT_APP_API_URL;
const enviromentUrl = process.env.REACT_APP_ENVIROMENT

function* getAnalyticsHighlights(actions) {

  let uuid = getSetCookie()
  try {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${actions.access}`,
      "X-RealmUuid": uuid
    };

    const requestOptions = {
      headers: headers
    };

    let url = apiUrl + "/opa-analytics"

    if (enviromentUrl !== "") {
      if (url.includes("?")) {
        url += `&env=${enviromentUrl}`;
      } else {
        url += `?env=${enviromentUrl}`;
      }
    }

    const response = yield call(apiCall, "get", url, requestOptions);

    yield put({
      type: "ANALYTICS_HIGHLIGHTS_RESPONSE_GET",
      value: {
        ...response,
        responseStatus: response.statusCode === 500 ? "error" : "success",
      },
      uuid: uuid
    });
  } catch (error) {
    yield put({
      type: "ANALYTICS_HIGHLIGHTS_RESPONSE_GET",
      value: { ...error, responseStatus: "error" },
    });
  }
}

function* resetAnalyticsHighlights() {
  yield put({ type: "ANALYTICS_HIGHLIGHTS_RESPONSE_RESET" });
}

export function* getSagaAnalyticsHighlights() {
  yield takeEvery("GET_ANALYTICS_HIGHLIGHTS", getAnalyticsHighlights);
}

export function* resetSagaAnalyticsHighlights() {
  yield takeEvery("RESET_ANALYTICS_HIGHLIGHTS", resetAnalyticsHighlights);
}

const getSetCookie = () => {
  return window.localStorage.getItem("uuidSetCookie");
};
